import fetchWithRetry from './fetchWithRetry';
import type RequestOptions from './RequestOptions';
import type MailboxRequestOptions from './MailboxRequestOptions';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getB2ServiceEndpoint } from 'owa-b2-flight/lib/getB2ServiceEndpoint';
import { type B2ServiceApiMode } from 'owa-b2-flight/lib/B2ServiceApiMode';
import { makeServiceRequestA } from './ServiceRequest';

export function makeServiceRequestB2<T>(
    actionName: string,
    endpoint: string,
    parameters: any,
    b2ServiceApiMode: B2ServiceApiMode,
    options?: RequestOptions | MailboxRequestOptions
): Promise<T> {
    if (b2ServiceApiMode === 1) {
        // TODO : Add telemetry for Shadow calls failures
        fetchB2Service<T>(actionName, endpoint, parameters, false /* fallback */, options).catch(
            () => {
                // TODO: Add telemetry for Shadow call failures
            }
        );

        return makeServiceRequestA<T>(actionName, endpoint, parameters, options);
    }
    return fetchB2Service<T>(actionName, endpoint, parameters, true /* fallback */, options);
}

function fetchB2Service<T>(
    actionName: string,
    endpoint: string,
    parameters: any,
    fallback: boolean,
    options?: RequestOptions | MailboxRequestOptions
) {
    const b2ServiceEndpoint = getB2ServiceEndpoint(endpoint);
    const wantJsonResponse =
        !options?.returnResponseHeaders && !options?.returnFullResponseOnSuccess;
    const b2ServiceOptions: RequestOptions | MailboxRequestOptions = {
        ...options,
        returnResponseHeaders: true,
    };
    // We know this is a owaB2Service request so add x-responseorigin OwaB2Service in case we get a 404 or for whatever reason x-responseorigin isn't sent in the service response header.
    b2ServiceOptions.datapoint ??= {};
    b2ServiceOptions.datapoint.customData ??= {};
    b2ServiceOptions.datapoint.customData.responseOrigin = 'OwaB2Service';
    return fetchWithRetry(actionName, b2ServiceEndpoint, 1, b2ServiceOptions, parameters)
        .then(response => {
            if (
                fallback &&
                typeof response.status === 'number' &&
                !isSuccessStatusCode(response.status)
            ) {
                throw new Error('B2Service response did not succeed');
            }
            if (wantJsonResponse) {
                return response.json();
            }
            return Promise.resolve(response);
        })
        .then(response => response)
        .catch(error => {
            if (fallback) {
                // TODO : Add telemetry here fallback observed for B2 failures
                const fallbackOptions: RequestOptions | MailboxRequestOptions = { ...options };
                fallbackOptions.datapoint ??= {};
                fallbackOptions.datapoint.customData ??= {};
                fallbackOptions.datapoint.customData.B2ServiceFallback = true;

                return makeServiceRequestA<T>(actionName, endpoint, parameters, fallbackOptions);
            }
            throw error;
        });
}
